// extracted by mini-css-extract-plugin
module.exports = {"color-badge":"ColorBadge_color-badge__mc3Td","dot":"ColorBadge_dot__ziAjP"};